import React, { useEffect, useState } from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import { useAuth } from "../contexts/AuthContext";
import orderService from "../services/orderService";
import { Link } from "react-router-dom";
import { formatDate } from "../utils/dateUtils";
import {
  OrderStatus,
  OrderStatusLabels,
  PaymentMethodLabels,
} from "../constants/enums";
import { toast } from "react-toastify";
import { confirmAlert, showSuccessAlert } from "../utils/alertHelpers";

// OrderStatus enum - OrderSuccessPage.jsx dosyasıyla uyumlu olması için aynı değerler kullanılıyor
const OrdersPage = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [viewingDetails, setViewingDetails] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [cancelLoading, setCancelLoading] = useState(false);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await orderService.getUserOrders();
        if (response.succeeded) {
          // Siparişlerin teslimat bilgilerini kontrol edelim
          const validatedOrders = response.orders.map((order) => {
            // Eğer shippingAddress yoksa veya boşsa basit bir nesne ile dolduralım
            if (!order.shippingAddress) {
              order.shippingAddress = {
                firstName: "",
                lastName: "",
                address: "Teslimat bilgileri mevcut değil",
                city: "",
                district: "",
                phone: "",
              };
            }
            return order;
          });
          setOrders(validatedOrders);
        } else {
          setError(response.message || "Siparişler alınırken bir hata oluştu");
        }
        setLoading(false);
      } catch (err) {
        console.error("Siparişler alınamadı:", err);
        setError(
          "Siparişleriniz alınırken bir hata oluştu. Lütfen daha sonra tekrar deneyin."
        );
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const handleViewDetails = async (orderId) => {
    setLoading(true);
    try {
      const response = await orderService.getOrderDetails(orderId);
      if (response.succeeded) {
        // Eğer teslimat bilgileri yoksa veya boşsa basit bir nesne oluşturalım
        if (!response.order.shippingAddress) {
          response.order.shippingAddress = {
            firstName: "",
            lastName: "",
            address: "Teslimat bilgileri mevcut değil",
            city: "",
            district: "",
            phone: "",
          };
        }
        setSelectedOrder(response.order);
        setViewingDetails(true);
      } else {
        setError(
          response.message || "Sipariş detayları alınırken bir hata oluştu"
        );
      }
      setLoading(false);
    } catch (err) {
      console.error("Sipariş detayları alınamadı:", err);
      setError(
        "Sipariş detayları alınırken bir hata oluştu. Lütfen daha sonra tekrar deneyin."
      );
      setLoading(false);
    }
  };

  const handleBackToOrders = () => {
    setViewingDetails(false);
    setSelectedOrder(null);
  };

  // Sipariş iptal fonksiyonu
  const handleCancelOrder = async (orderId) => {
    const isConfirmed = await confirmAlert(
      "Siparişi İptal Et",
      "Siparişinizi iptal etmek istediğinize emin misiniz?",
      "Evet, İptal Et",
      "Vazgeç"
    );

    if (isConfirmed) {
      processCancelOrder(orderId);
    }
  };

  // Sipariş iptal işlemini gerçekleştirir
  const processCancelOrder = async (orderId) => {
    setCancelLoading(true);
    try {
      const response = await orderService.cancelOrder(orderId);
      if (response.succeeded) {
        showSuccessAlert(
          "İşlem Başarılı",
          "Siparişiniz başarıyla iptal edildi."
        );

        // Siparişleri yenile
        const updatedOrders = orders.map((order) =>
          order.id === orderId
            ? { ...order, status: OrderStatus.Canceled }
            : order
        );
        setOrders(updatedOrders);
      } else {
        toast.error(
          response.message || "Sipariş iptal edilirken bir hata oluştu"
        );
      }
    } catch (err) {
      console.error("Sipariş iptal hatası:", err);
      toast.error(
        "Sipariş iptal edilirken bir hata oluştu. Lütfen daha sonra tekrar deneyin."
      );
    } finally {
      setCancelLoading(false);
    }
  };

  // Sipariş detayını göster/gizle
  const toggleOrderDetails = (orderId) => {
    if (expandedOrderId === orderId) {
      setExpandedOrderId(null);
    } else {
      setExpandedOrderId(orderId);
    }
  };

  // Sipariş iptal edilebilir mi kontrolü - İPTAL BUTONU GÖRÜNMEZ HALE GETİRİLDİ
  const canCancelOrder = (status) => {
    // İptal butonu geçici olarak devre dışı bırakıldı
    return false;
    
    // Orijinal kod (yorum olarak bırakıldı):
    // const numericStatus = Number(status);
    // return (
    //   !isNaN(numericStatus) &&
    //   (numericStatus === OrderStatus.Pending ||
    //     numericStatus === OrderStatus.Processing ||
    //     numericStatus === OrderStatus.PaymentCompleted ||
    //     numericStatus === OrderStatus.BankTransferPending)
    // );
  };

  // Sipariş durumuna göre renk belirleme
  const getStatusColor = (status) => {
    // Status null veya undefined ise varsayılan değer döndür
    if (status === null || status === undefined) {
      return "bg-secondary";
    }

    // Status numerik değer (enum) ise
    const numericStatus = Number(status);
    if (!isNaN(numericStatus)) {
      switch (numericStatus) {
        case OrderStatus.Pending:
        case OrderStatus.BankTransferPending:
        case OrderStatus.PaymentWaiting3DSecure:
          return "bg-warning";
        case OrderStatus.Processing:
        case OrderStatus.PaymentCompleted:
          return "bg-info";
        case OrderStatus.Shipped:
          return "bg-primary";
        case OrderStatus.Delivered:
          return "bg-success";
        case OrderStatus.Canceled:
        case OrderStatus.PaymentFailed:
          return "bg-danger";
        case OrderStatus.Returned:
        case OrderStatus.Refunded:
          return "bg-secondary";
        default:
          return "bg-secondary";
      }
    }

    // String olarak geldiyse (geriye dönük uyumluluk için)
    if (typeof status === "string") {
      const lowerStatus = status.toLowerCase();
      if (lowerStatus.includes("pending") || lowerStatus.includes("bekliyor")) {
        return "bg-warning";
      } else if (
        lowerStatus.includes("processing") ||
        lowerStatus.includes("işleniyor")
      ) {
        return "bg-info";
      } else if (
        lowerStatus.includes("shipped") ||
        lowerStatus.includes("kargoda")
      ) {
        return "bg-primary";
      } else if (
        lowerStatus.includes("delivered") ||
        lowerStatus.includes("teslim")
      ) {
        return "bg-success";
      } else if (
        lowerStatus.includes("cancel") ||
        lowerStatus.includes("iptal")
      ) {
        return "bg-danger";
      } else if (
        lowerStatus.includes("return") ||
        lowerStatus.includes("iade") ||
        lowerStatus.includes("refund") ||
        lowerStatus.includes("geri")
      ) {
        return "bg-secondary";
      }
    }

    return "bg-secondary";
  };

  // Sipariş durumunu metin olarak döndür
  const getStatusText = (status) => {
    // Status null veya undefined ise varsayılan değer döndür
    if (status === null || status === undefined) {
      return "Bekliyor";
    }

    // Status numerik değer (enum) ise
    const numericStatus = Number(status);
    if (!isNaN(numericStatus)) {
      // PaymentCompleted durumunu Hazırlanıyor olarak göster
      if (numericStatus === OrderStatus.PaymentCompleted) {
        return "Hazırlanıyor";
      }
      return OrderStatusLabels[numericStatus] || "Bekliyor";
    }

    // String olarak geldiyse orijinal değeri döndür (geriye dönük uyumluluk)
    return status;
  };

  // Ödeme yöntemi Türkçe çevirisi
  const getPaymentMethodText = (method) => {
    return PaymentMethodLabels[method] || method;
  };

  // Filtrelenmiş siparişleri getir
  const getFilteredOrders = () => {
    if (activeTab === "all") return orders;

    // Duruma göre filtreleme (enum değerlerine göre güncellendi)
    switch (activeTab) {
      case "pending":
        return orders.filter((order) => {
          const status = Number(order.status);
          return (
            !isNaN(status) &&
            (status === OrderStatus.Pending ||
              status === OrderStatus.BankTransferPending ||
              status === OrderStatus.PaymentWaiting3DSecure)
          );
        });
      case "processing":
        return orders.filter((order) => {
          const status = Number(order.status);
          return (
            !isNaN(status) &&
            (status === OrderStatus.Processing ||
              status === OrderStatus.PaymentCompleted)
          );
        });
      case "shipped":
        return orders.filter((order) => {
          const status = Number(order.status);
          return !isNaN(status) && status === OrderStatus.Shipped;
        });
      case "delivered":
        return orders.filter((order) => {
          const status = Number(order.status);
          return !isNaN(status) && status === OrderStatus.Delivered;
        });
      case "cancelled":
        return orders.filter((order) => {
          const status = Number(order.status);
          return (
            !isNaN(status) &&
            (status === OrderStatus.Canceled ||
              status === OrderStatus.Returned ||
              status === OrderStatus.Refunded ||
              status === OrderStatus.PaymentFailed)
          );
        });
      default:
        return orders;
    }
  };

  return (
    <>
      <ColorInit color={false} />
      <ScrollToTop smooth color="#299E60" />
      <Preloader />
      <HeaderOne />
      <Breadcrumb title={"Siparişlerim"} />

      <section className="account py-80">
        <div className="container container-lg">
          {loading ? (
            <div className="text-center py-40">
              <div className="spinner-border text-main-600" role="status">
                <span className="visually-hidden">Yükleniyor...</span>
              </div>
            </div>
          ) : error ? (
            <div className="alert alert-danger rounded-16 py-16 px-24 mb-0">
              {error}
            </div>
          ) : viewingDetails && selectedOrder ? (
            // Sipariş Detay Görünümü
            <div className="order-details">
              <div className="row mb-32">
                <div className="col-12">
                  <button
                    onClick={handleBackToOrders}
                    className="btn btn-outline-main py-12 px-24 rounded-8"
                  >
                    <i className="ph ph-arrow-left me-8"></i>
                    Siparişlere Dön
                  </button>
                </div>
              </div>

              <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-32 mb-40">
                <div className="d-flex justify-content-between align-items-center border-bottom border-gray-100 pb-16 mb-24">
                  <h5 className="text-xl fw-semibold text-neutral-900 mb-0">
                    Sipariş #{selectedOrder.orderNumber}
                    <span className="fs-6 text-gray-500 ms-8">
                      ({formatDate(selectedOrder.orderDate)})
                    </span>
                  </h5>
                  <span
                    className={`badge rounded-8 py-8 px-12 ${getStatusColor(
                      selectedOrder.status
                    )}`}
                  >
                    {getStatusText(selectedOrder.status)}
                  </span>
                </div>
                <div className="row gy-24 mb-32">
                  <div className="col-md-6">
                    <ul className="list-unstyled mb-0">
                      <li className="mb-16 text-lg">
                        <span className="text-gray-500">Sipariş Tarihi:</span>
                        <span className="ms-8 text-neutral-900 fw-medium">
                          {formatDate(selectedOrder.orderDate)}
                        </span>
                      </li>
                      <li className="mb-16 text-lg">
                        <span className="text-gray-500">Ödeme Yöntemi:</span>
                        <span className="ms-8 text-neutral-900 fw-medium">
                          {getPaymentMethodText(selectedOrder.paymentMethod)}
                        </span>
                      </li>
                      <li className="mb-16 text-lg">
                        <span className="text-gray-500">Ürün Toplamı:</span>
                        <span className="ms-8 text-neutral-900 fw-medium">
                          {selectedOrder.totalAmount.toFixed(2)} ₺
                        </span>
                      </li>
                      <li className="mb-16 text-lg">
                        <span className="text-gray-500">Kargo Ücreti:</span>
                        <span className="ms-8 text-neutral-900 fw-medium">
                          {selectedOrder.shippingCost.toFixed(2)} ₺
                        </span>
                      </li>
                      <li className="text-lg">
                        <span className="text-gray-500">Toplam Tutar:</span>
                        <span className="ms-8 text-main-600 fw-bold">
                          {(
                            selectedOrder.totalAmount +
                            (selectedOrder.shippingCost || 0)
                          ).toFixed(2)}{" "}
                          ₺
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <div className="bg-gray-50 p-24 rounded-12">
                      <h6 className="text-lg fw-semibold text-neutral-900 mb-16">
                        Sipariş Takibi
                      </h6>
                      {selectedOrder.historyLogs &&
                      selectedOrder.historyLogs.length > 0 ? (
                        <div className="position-relative">
                          <div
                            className="position-absolute h-100"
                            style={{
                              left: "7px",
                              width: "2px",
                              backgroundColor: "#e5e7eb",
                            }}
                          ></div>
                          {[...selectedOrder.historyLogs]
                            .sort(
                              (a, b) =>
                                new Date(a.logDate) - new Date(b.logDate)
                            )
                            .map((log, index) => (
                              <div
                                key={index}
                                className="d-flex mb-16 position-relative"
                              >
                                <div
                                  className={`rounded-circle flex-shrink-0 ${getStatusColor(
                                    log.newStatus
                                  )}`}
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    marginRight: "12px",
                                    zIndex: "1",
                                  }}
                                ></div>
                                <div className="flex-grow-1">
                                  <div className="d-flex flex-column">
                                    <span className="fw-medium text-neutral-900">
                                      {OrderStatusLabels[log.newStatus] ||
                                        getStatusText(log.newStatus)}
                                    </span>
                                    <span className="text-gray-500 text-sm">
                                      {formatDate(log.logDate)}
                                    </span>
                                    {log.note && (
                                      <span className="text-gray-600 text-sm mt-4 fst-italic">
                                        {log.note}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      ) : (
                        <div className="d-flex flex-column">
                          <span className="text-lg mb-2">
                            <i className="ph ph-clock text-main-600 me-2"></i>
                            Sipariş Tarihi:{" "}
                            <span className="fw-medium">
                              {formatDate(selectedOrder.orderDate)}
                            </span>
                          </span>
                          <span className="text-lg mb-2">
                            <i className="ph ph-check-circle text-main-600 me-2"></i>
                            Sipariş Durumu:{" "}
                            <span
                              className={`badge ${getStatusColor(
                                selectedOrder.status
                              )}`}
                            >
                              {getStatusText(selectedOrder.status)}
                            </span>
                          </span>
                          {selectedOrder.estimatedDeliveryDate && (
                            <span className="text-lg mt-2">
                              <i className="ph ph-truck text-main-600 me-2"></i>
                              Tahmini Teslimat:{" "}
                              <span className="fw-medium">
                                {formatDate(
                                  selectedOrder.estimatedDeliveryDate
                                )}
                              </span>
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <h6 className="text-lg fw-semibold text-neutral-900 mb-16">
                  Sipariş Öğeleri
                </h6>
                {selectedOrder.items.map((item) => (
                  <div
                    key={item.id}
                    className="d-flex align-items-center border-top border-gray-100 py-16"
                  >
                    <div className="flex-shrink-0">
                      {item.productImage ? (
                        <img
                          src={item.productImage}
                          alt={item.productName}
                          className="rounded-8"
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "cover",
                          }}
                        />
                      ) : item.productName.startsWith(
                          "Özelleştirilmiş Paket"
                        ) ? (
                        <i
                          className="ph ph-package text-main-600"
                          style={{ fontSize: "80px" }}
                          title={item.productName}
                        ></i>
                      ) : null}
                    </div>
                    <div className="ms-16 flex-grow-1">
                      <Link
                        to={`/product-details/${item.productId}`}
                        className="text-neutral-900 hover-text-main-600 transition-1 fw-medium"
                      >
                        {item.productName}
                      </Link>
                      {/* Küçük paket detaylarını göster */}
                      {!item.productImage &&
                        item.productName.startsWith(
                          "Özelleştirilmiş Paket"
                        ) && (
                          <div className="text-sm text-gray-500 fst-italic mt-2">
                            {item.productName.split(": ")[1]}
                          </div>
                        )}
                      <div className="d-flex flex-wrap mt-8">
                        <div className="me-16 text-gray-500">
                          Adet:{" "}
                          <span className="text-neutral-900">
                            {item.quantity}
                          </span>
                        </div>
                        <div className="me-16 text-gray-500">
                          Birim Fiyat:
                          {item.discountedPrice ? (
                            <>
                              <span className="text-gray-400 text-decoration-line-through ms-4 me-4">
                                {item.unitPrice.toFixed(2)} ₺
                              </span>
                              <span className="text-danger fw-medium">
                                {item.discountedPrice.toFixed(2)} ₺
                              </span>
                            </>
                          ) : (
                            <span className="text-neutral-900 ms-4">
                              {item.unitPrice.toFixed(2)} ₺
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="ms-auto text-end">
                      <span className="fw-bold text-main-600">
                        {item.totalPrice.toFixed(2)} ₺
                      </span>
                    </div>
                  </div>
                ))}

                {selectedOrder.notes && (
                  <div className="mt-32">
                    <h6 className="text-lg fw-semibold text-neutral-900 mb-16">
                      Sipariş Notları
                    </h6>
                    <p className="border border-gray-100 rounded-12 p-24 bg-gray-50 text-gray-500 mb-0">
                      {selectedOrder.notes}
                    </p>
                  </div>
                )}

                {/* Teslimat ve Fatura Adresi Bilgileri */}
                <div className="mt-32">
                  <h6 className="text-lg fw-semibold text-neutral-900 mb-16">
                    Teslimat Adresi
                  </h6>
                  <div className="border border-gray-100 rounded-12 p-24 bg-gray-50">
                    {selectedOrder.shippingAddress ? (
                      <>
                        <div className="d-flex align-items-center mb-12">
                          <i className="ph ph-map-pin text-main-600 me-12 fs-5"></i>
                          <span className="fw-medium text-neutral-900">
                            {selectedOrder.shippingAddress.firstName}{" "}
                            {selectedOrder.shippingAddress.lastName}
                          </span>
                        </div>
                        <p className="mb-8 text-gray-600">
                          {selectedOrder.shippingAddress.address}
                        </p>
                        <p className="mb-8 text-gray-600">
                          {selectedOrder.shippingAddress.district &&
                            `${selectedOrder.shippingAddress.district}, `}
                          {selectedOrder.shippingAddress.city}
                        </p>
                        {selectedOrder.shippingAddress.phone && (
                          <p className="mb-0 text-gray-600">
                            <i className="ph ph-phone text-main-600 me-8"></i>
                            {selectedOrder.shippingAddress.phone}
                          </p>
                        )}
                      </>
                    ) : (
                      <p className="text-gray-500 mb-0">
                        Teslimat adresi bilgisi bulunamadı.
                      </p>
                    )}
                  </div>

                  {/* Fatura Adresi Bilgileri */}
                  {selectedOrder.useSameAddressForBilling ? (
                    <div className="mt-16">
                      <div className="border border-gray-100 rounded-12 p-24 bg-gray-50">
                        <div className="d-flex align-items-center mb-12">
                          <i className="ph ph-receipt text-main-600 me-12 fs-5"></i>
                          <span className="fw-medium text-neutral-900">
                            Fatura Adresi
                          </span>
                        </div>
                        <p className="text-gray-600 mb-0">
                          <i className="ph ph-info-circle text-main-600 me-8"></i>
                          Fatura ve teslimat adresleriniz aynıdır.
                        </p>
                      </div>
                    </div>
                  ) : selectedOrder.billingAddress ? (
                    <div className="mt-16">
                      <h6 className="text-lg fw-semibold text-neutral-900 mb-16">
                        Fatura Adresi
                      </h6>
                      <div className="border border-gray-100 rounded-12 p-24 bg-gray-50">
                        <div className="d-flex align-items-center mb-12">
                          <i className="ph ph-receipt text-main-600 me-12 fs-5"></i>
                          <span className="fw-medium text-neutral-900">
                            {selectedOrder.billingAddress.firstName}{" "}
                            {selectedOrder.billingAddress.lastName}
                          </span>
                        </div>
                        <p className="mb-8 text-gray-600">
                          {selectedOrder.billingAddress.address}
                        </p>
                        <p className="mb-8 text-gray-600">
                          {selectedOrder.billingAddress.district &&
                            `${selectedOrder.billingAddress.district}, `}
                          {selectedOrder.billingAddress.city}
                        </p>
                        {selectedOrder.billingAddress.phone && (
                          <p className="mb-0 text-gray-600">
                            <i className="ph ph-phone text-main-600 me-8"></i>
                            {selectedOrder.billingAddress.phone}
                          </p>
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          ) : (
            // Siparişler Listesi Görünümü
            <div className="row">
              <div className="col-12">
                <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-24 mb-32">
                  <div className="row mb-24">
                    <div className="col-md-6">
                      <h2 className="text-xl fw-semibold text-neutral-900 mb-0">
                        Siparişlerim
                      </h2>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex justify-content-md-end">
                        <div className="position-relative">
                          <input
                            type="text"
                            className="form-control rounded-8 py-12 ps-16 pe-40"
                            placeholder="Sipariş numarası veya ürün ara"
                          />
                          <span className="position-absolute top-50 end-0 translate-middle-y pe-16">
                            <i className="ph ph-magnifying-glass text-gray-500"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <ul className="nav nav-tabs border-bottom border-gray-100 mb-24">
                    <li className="nav-item">
                      <button
                        className={`nav-link border-0 px-16 py-12 ${
                          activeTab === "all"
                            ? "active fw-medium text-main-600 border-bottom border-main-600"
                            : "text-gray-500"
                        }`}
                        onClick={() => setActiveTab("all")}
                      >
                        Tümü
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link border-0 px-16 py-12 ${
                          activeTab === "pending"
                            ? "active fw-medium text-main-600 border-bottom border-main-600"
                            : "text-gray-500"
                        }`}
                        onClick={() => setActiveTab("pending")}
                      >
                        Bekleyen
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link border-0 px-16 py-12 ${
                          activeTab === "processing"
                            ? "active fw-medium text-main-600 border-bottom border-main-600"
                            : "text-gray-500"
                        }`}
                        onClick={() => setActiveTab("processing")}
                      >
                        Hazırlanıyor
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link border-0 px-16 py-12 ${
                          activeTab === "shipped"
                            ? "active fw-medium text-main-600 border-bottom border-main-600"
                            : "text-gray-500"
                        }`}
                        onClick={() => setActiveTab("shipped")}
                      >
                        Kargoda
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link border-0 px-16 py-12 ${
                          activeTab === "delivered"
                            ? "active fw-medium text-main-600 border-bottom border-main-600"
                            : "text-gray-500"
                        }`}
                        onClick={() => setActiveTab("delivered")}
                      >
                        Teslim Edilenler
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link border-0 px-16 py-12 ${
                          activeTab === "cancelled"
                            ? "active fw-medium text-main-600 border-bottom border-main-600"
                            : "text-gray-500"
                        }`}
                        onClick={() => setActiveTab("cancelled")}
                      >
                        İptal Edilenler
                      </button>
                    </li>
                  </ul>

                  {getFilteredOrders().length === 0 ? (
                    <div className="text-center py-40">
                      <div className="mb-24">
                        <i
                          className="ph ph-shopping-bag text-main-600"
                          style={{ fontSize: "4rem" }}
                        ></i>
                      </div>
                      <h4 className="text-neutral-900 mb-16">
                        Bu kategoride sipariş bulunamadı
                      </h4>
                      <p className="text-gray-500 mb-24">
                        Alışverişe başlamak için mağazayı ziyaret edebilirsiniz.
                      </p>
                      <Link
                        to="/shop"
                        className="btn btn-main py-16 px-40 rounded-8"
                      >
                        Alışverişe Başla
                      </Link>
                    </div>
                  ) : (
                    getFilteredOrders().map((order) => (
                      <div
                        key={order.id}
                        className="border border-gray-100 rounded-12 p-24 mb-16 transition-1 hover-shadow-sm"
                      >
                        <div className="row">
                          <div className="col-md-12">
                            <div className="d-flex align-items-center mb-16">
                              <h6 className="fw-semibold text-neutral-900 mb-0">
                                Sipariş #{order.orderNumber}
                              </h6>
                              <span className="ms-12 text-gray-500">
                                ({formatDate(order.orderDate)})
                              </span>
                              <span
                                className={`ms-auto badge rounded-8 py-8 px-12 ${getStatusColor(
                                  order.status
                                )}`}
                              >
                                {getStatusText(order.status)}
                              </span>
                            </div>
                            <div className="d-flex flex-wrap">
                              <div className="me-24 mb-16">
                                <div className="text-sm text-gray-500 mb-4">
                                  Ürün Sayısı
                                </div>
                                <div className="fw-medium">
                                  {order.itemCount !== undefined
                                    ? order.itemCount
                                    : 0}{" "}
                                  Ürün
                                </div>
                              </div>
                              <div className="me-24 mb-16">
                                <div className="text-sm text-gray-500 mb-4">
                                  Ödeme Yöntemi
                                </div>
                                <div className="fw-medium">
                                  {getPaymentMethodText(order.paymentMethod)}
                                </div>
                              </div>
                              <div className="me-24 mb-16">
                                <div className="text-sm text-gray-500 mb-4">
                                  Kargo Ücreti
                                </div>
                                <div className="fw-medium">
                                  {order.shippingCost > 0
                                    ? `${order.shippingCost.toFixed(2)} ₺`
                                    : "Ücretsiz"}
                                </div>
                              </div>
                              <div className="mb-16">
                                <div className="text-sm text-gray-500 mb-4">
                                  Toplam Tutar
                                </div>
                                <div className="fw-bold text-main-600">
                                  {order.totalAmount.toFixed(2)} ₺
                                </div>
                              </div>
                            </div>

                            {/* İşlem butonları */}
                            <div className="d-flex mt-16">
                              <button
                                onClick={() => toggleOrderDetails(order.id)}
                                className="btn btn-outline-main py-12 px-24 rounded-8 me-16"
                              >
                                <i
                                  className={`ph ${
                                    expandedOrderId === order.id
                                      ? "ph-caret-up"
                                      : "ph-caret-down"
                                  } me-8`}
                                ></i>
                                {expandedOrderId === order.id
                                  ? "Detayları Gizle"
                                  : "Detayları Göster"}
                              </button>

                              {canCancelOrder(order.status) && (
                                <button
                                  onClick={() => handleCancelOrder(order.id)}
                                  className="btn btn-danger btn-outline py-12 px-24 rounded-8"
                                  disabled={cancelLoading}
                                >
                                  {cancelLoading ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm me-8"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      İşlem Yapılıyor...
                                    </>
                                  ) : (
                                    <>
                                      <i className="ph ph-x-circle me-8"></i>{" "}
                                      Siparişi İptal Et
                                    </>
                                  )}
                                </button>
                              )}
                            </div>

                            {/* Genişletilmiş detaylar */}
                            {expandedOrderId === order.id && (
                              <div className="mt-24 pt-16 border-top border-gray-100">
                                <div className="d-flex justify-content-between mb-16">
                                  <h6 className="fw-semibold text-neutral-900">
                                    Sipariş Özeti
                                  </h6>
                                  <button
                                    onClick={() => handleViewDetails(order.id)}
                                    className="btn btn-sm btn-outline-main rounded-8 py-8 px-16"
                                  >
                                    <i className="ph ph-eye me-8"></i>Tüm
                                    Detayları Gör
                                  </button>
                                </div>

                                <div className="row mb-16">
                                  <div className="col-12">
                                    <div className="bg-gray-50 p-16 rounded-12">
                                      <h6 className="text-sm fw-semibold text-neutral-900 mb-12">
                                        Sipariş Takibi
                                      </h6>
                                      <div className="d-flex flex-column">
                                        {order.statusHistory &&
                                        order.statusHistory.length > 0 ? (
                                          <div className="position-relative">
                                            <div
                                              className="position-absolute h-100"
                                              style={{
                                                left: "7px",
                                                width: "2px",
                                                backgroundColor: "#e5e7eb",
                                              }}
                                            ></div>
                                            {order.statusHistory.map(
                                              (historyItem, index) => (
                                                <div
                                                  key={index}
                                                  className="d-flex mb-16 position-relative"
                                                >
                                                  <div
                                                    className={`rounded-circle flex-shrink-0 ${getStatusColor(
                                                      historyItem.status
                                                    )}`}
                                                    style={{
                                                      width: "16px",
                                                      height: "16px",
                                                      marginRight: "12px",
                                                      zIndex: "1",
                                                    }}
                                                  ></div>
                                                  <div className="flex-grow-1">
                                                    <div className="d-flex flex-column">
                                                      <span className="fw-medium text-neutral-900">
                                                        {OrderStatusLabels[
                                                          historyItem.status
                                                        ] ||
                                                          getStatusText(
                                                            historyItem.status
                                                          )}
                                                      </span>
                                                      <span className="text-gray-500 text-sm">
                                                        {formatDate(
                                                          historyItem.date
                                                        )}
                                                      </span>
                                                      {historyItem.note && (
                                                        <span className="text-gray-600 text-sm mt-4 fst-italic">
                                                          {historyItem.note}
                                                        </span>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        ) : (
                                          <div className="d-flex flex-column">
                                            <span className="text-sm mb-2">
                                              <i className="ph ph-clock text-main-600 me-2"></i>
                                              Sipariş Tarihi:{" "}
                                              <span className="fw-medium">
                                                {formatDate(order.orderDate)}
                                              </span>
                                            </span>
                                            <span className="text-sm mb-2">
                                              <i className="ph ph-check-circle text-main-600 me-2"></i>
                                              Sipariş Durumu:{" "}
                                              <span
                                                className={`badge ${getStatusColor(
                                                  order.status
                                                )} py-4 px-8`}
                                              >
                                                {getStatusText(order.status)}
                                              </span>
                                            </span>
                                            {order.statusUpdateDate && (
                                              <span className="text-sm mb-2">
                                                <i className="ph ph-arrow-circle-right text-main-600 me-2"></i>
                                                Son Güncelleme:{" "}
                                                <span className="fw-medium">
                                                  {formatDate(
                                                    order.statusUpdateDate
                                                  )}
                                                </span>
                                              </span>
                                            )}
                                            {order.estimatedDeliveryDate && (
                                              <span className="text-sm">
                                                <i className="ph ph-truck text-main-600 me-2"></i>
                                                Tahmini Teslimat:{" "}
                                                <span className="fw-medium">
                                                  {formatDate(
                                                    order.estimatedDeliveryDate
                                                  )}
                                                </span>
                                              </span>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {order.notes && (
                                  <div className="bg-gray-50 p-16 rounded-12 mb-16">
                                    <h6 className="text-sm fw-semibold text-neutral-900 mb-8">
                                      Sipariş Notları
                                    </h6>
                                    <p className="text-gray-500 text-sm mb-0">
                                      {order.notes}
                                    </p>
                                  </div>
                                )}

                                {Number(order.status) ===
                                  OrderStatus.Canceled &&
                                  order.cancellationReason && (
                                    <div className="bg-danger bg-opacity-10 p-16 rounded-12 mb-16">
                                      <h6 className="text-sm fw-semibold text-danger mb-8">
                                        İptal Nedeni
                                      </h6>
                                      <p className="text-danger text-sm mb-0">
                                        {order.cancellationReason}
                                      </p>
                                    </div>
                                  )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <ShippingOne />
      <FooterOne />
      <BottomFooter />
    </>
  );
};

export default OrdersPage;
